/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ServiceLocationSeoFields
 */
export interface ServiceLocationSeoFields {
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFields
   */
  locationSlug?: string | null
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFields
   */
  header?: string | null
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFields
   */
  titleTag?: string | null
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFields
   */
  descriptionTag?: string | null
  /**
   *
   * @type {string}
   * @memberof ServiceLocationSeoFields
   */
  description?: string | null
}

/**
 * Check if a given object implements the ServiceLocationSeoFields interface.
 */
export function instanceOfServiceLocationSeoFields(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function ServiceLocationSeoFieldsFromJSON(json: any): ServiceLocationSeoFields {
  return ServiceLocationSeoFieldsFromJSONTyped(json, false)
}

export function ServiceLocationSeoFieldsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServiceLocationSeoFields {
  if (json === undefined || json === null) {
    return json
  }
  return {
    locationSlug: !exists(json, 'locationSlug') ? undefined : json['locationSlug'],
    header: !exists(json, 'header') ? undefined : json['header'],
    titleTag: !exists(json, 'titleTag') ? undefined : json['titleTag'],
    descriptionTag: !exists(json, 'descriptionTag') ? undefined : json['descriptionTag'],
    description: !exists(json, 'description') ? undefined : json['description'],
  }
}

export function ServiceLocationSeoFieldsToJSON(value?: ServiceLocationSeoFields | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    locationSlug: value.locationSlug,
    header: value.header,
    titleTag: value.titleTag,
    descriptionTag: value.descriptionTag,
    description: value.description,
  }
}
